import React, { ReactNodeArray, Fragment, useEffect } from 'react';
import { useSprings, animated } from 'react-spring';

require('./SetupPanelContainer.css');

export type Props = {
    activeIndex: number;
    children?: ReactNodeArray;
};

export const SetupPanelContainer = ({ activeIndex = 0, children = [] }: Props) => {
    const [ springs, springsAnim ] = useSprings(children.length, i => ({
        opacity: i === activeIndex ? 1 : 0,
        y: activeIndex === i ? 0 : i < activeIndex ? -100 : 100,
    }));

    useEffect(() => {
        springsAnim.start(i => ({
            opacity: i === activeIndex ? 1 : 0,
            y: activeIndex === i ? 0 : i < activeIndex ? -100 : 100,
        }));

        return () => {
            springsAnim.stop();
        };
    }, [ activeIndex, springsAnim ]);

    return (
        <Fragment>
            { springs.map((style, i) =>
                <animated.div
                    key={ i }
                    style={ style }
                    className={ `panel-host${activeIndex === i ? ' active-panel' : ''}` }
                >
                    { children[i] }
                </animated.div>
            ) }
        </Fragment>
    );
};
